import { render, staticRenderFns } from "./DeleteMicroprotocolDialog.vue?vue&type=template&id=5c21d6cc&"
import script from "./DeleteMicroprotocolDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteMicroprotocolDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports